/**
 * @Author: v_jppjpeng
 * @Date: 2022-09-22 16:06:22
 * @Explain: 用户管理
 */

export default {
  // 渠道类型
  'CONTACT.MANAGE.CHANNEL.TYPE.EMAIL': 'Email',
  'CONTACT.MANAGE.CHANNEL.TYPE.WHATSAPP': 'WhatsApp',
  'CONTACT.MANAGE.CHANNEL.TYPE.DISCORD': 'Discord',
  'CONTACT.MANAGE.CHANNEL.TYPE.STEAM': 'Steam',
  // 用户来源
  'CONTACT.SOURCE.LI-PASS': 'LIPass - SDK',
  'CONTACT.SOURCE.IN-GAME': 'Databrain',
  'CONTACT.SOURCE.FILE': 'CSV',
  'CONTACT.SOURCE.SINGLE-ADD': 'Individually added',
  'CONTACT.SOURCE.TOOLS': 'Tool - Backend',
  'CONTACT.SOURCE.DATA-SCIENCE-TEAM': 'Data Science Team',
  'CONTACT.SOURCE.NEWSLETTER-SIGN-UP': 'LIPass - WEB',
  'CONTACT.SOURCE.SIGN-UP-FORM': 'Form',
  'CONTACT.SOURCE.ASSOCIATE_GROUP': '',
  'CONTACT.SOURCE.WHATSAPP': 'WhatsApp',
  'CONTACT.SOURCE.DETAILS': 'Contact Details Page',
  'CONTACT.SOURCE.OPTIN': 'double opt-in',
  'CONTACT.SOURCE.JOURNEY': 'journey',
  'CONTACT.SOURCE.RECRUIT': 'Oficial website recruitment',

  // 联系人列表
  'CONTACT.LIST.PROFILE': 'Profile',

  // 联系人详情
  'CONTACT.DETAILS.CHANNEL.ID': 'ID',
  'CONTACT.DETAILS.CHANNEL.USERNAMEA': '{channelName} username',
  'CONTACT.DETAILS.CHANNEL.ACCOUNT.CREATED': 'Created On',
  'CONTACT.DETAILS.KRY': 'Steam key',
  'CONTACT.DETAILS.WISHLIST.LABEL': 'Steam Wishlist',
  'CONTACT.DETAILS.WISHLIST.STATUS': 'Wishlist Status',
  'CONTACT.DETAILS.PRIVATE.VALUE': 'Private',
  'CONTACT.DETAILS.UNKNOWN.VALUE': 'Unknown',
  'CONTACT.DETAILS.PLAYTIME.LABEL': 'Playtime',
  'CONTACT.DETAILS.PLAYTIME.PUBLIC.HOURS.VALUE': '{hours}hr ',
  'CONTACT.DETAILS.PLAYTIME.PUBLIC.MINS.VALUE': '{minutes}min',
  'CONTACT.DETAILS.WISHLIST.VALUE.1': 'Added',
  'CONTACT.DETAILS.WISHLIST.VALUE.2': 'Not Added',
  'CONTACT.DETAILS.NIGHT.MARKETING.LABEL': 'Nighttime Marketing Permission',
  'CONTACT.DETAILS.NIGHT.MARKETING.VALUE.1': 'Allow',
  'CONTACT.DETAILS.NIGHT.MARKETING.VALUE.2': 'Do not allow',
  'CONTACT.DETAILS.NIGHT.MARKETING.VALUE.3': 'Unknown',
  'CONTACT.DETAILS.NIGHT.MARKETING.BUBBLE':
    'If the user does not allow or has not yet allowed consent, the event will skip the nighttime period when sending.',

  // 用户 - 管理用户
  // 'CONTACT.MANAGE.LIST.TITLE': 'Contacts management',
  'CONTACT.MANAGE.FILTER.ALL': 'Match all',
  'CONTACT.MANAGE.FILTER.ANY': 'Match any',
  'CONTACT.MANAGE.FILTER.TAG.ALL.TIP':
    'Includes contacts who match all selected tags.',
  'CONTACT.MANAGE.FILTER.TAG.ANY.TIP':
    'Includes contacts who match at least 1 selected tag.',
  'CONTACT.MANAGE.FILTER.SOURCE.ALL.TIP':
    'Includes contacts who match all selected sources.',
  'CONTACT.MANAGE.FILTER.SOURCE.ANY.TIP':
    'Includes contacts who match at least 1 selected source.',
  'CONTACT.MANAGE.LIST.EMAIL.ADDRESS': 'Email',
  'CONTACT.MANAGE.LIST.CONTACTS.ADDRESS': 'Contacts',
  'CONTACT.MANAGE.LIST.LAST.CHANGE': 'Last changed',
  'CONTACT.MANAGE.LIST.MAIL.ADDRESS': 'Email address',
  'CONTACT.MANAGE.LIST.SEARCH.MAIL.ADDRESS': 'Search email',
  'CONTACT.MANAGE.LIST.SEARCH.MAIL.WHATSAPP.ADDRESS':
    'Search email / WhatsApp number',
  'CONTACT.MANAGE.LIST.SUBSCRIPTION.STATUS': 'Subscription status',
  'CONTACT.MANAGE.LIST.PREFERENCE': 'Preferences',
  'CONTACT.MANAGE.LIST.HIGH': 'High',
  'CONTACT.MANAGE.LIST.MEDIUM': 'Medium',
  'CONTACT.MANAGE.LIST.LOW': 'Low',
  'CONTACT.MANAGE.LIST.ENGAGEMENT.RATING': 'Engagement',
  'CONTACT.MANAGE.LIST.EDITOR': 'Edited by',
  'CONTACT.MANAGE.ADD.DATE': 'Date added',
  'CONTACT.MANAGE.LIST.LAST.SAVED': 'Last saved',
  'CONTACT.MANAGE.LIST.SUBSCRIBED': 'Subscribed',
  'CONTACT.MANAGE.LIST.UNSUBSCRIBED': 'Unsubscribed',
  'CONTACT.MANAGE.LIST.PENDING': 'Pending',
  'CONTACT.MANAGE.LIST.UNBOUND': 'Unbound',
  'CONTACT.MANAGE.LIST.EXPORT.SEGMENT': 'Export segment',
  'CONTACT.MANAGE.LIST.CREATE.CONTACT': 'Import contact(s)',
  'CONTACT.MANAGE.LIST.CREATE.CONTACT.TIPS':
    'Temporarily unavailable, only supports importing offline contact via API',
  'CONTACT.MANAGE.LIST.ADV.TIPS':
    'Sync real-time data from LEVEL INFINITE PASS into SmartLink, automatically giving you accurate, organized, and info-rich insights.',
  'CONTACT.MANAGE.LIST.GO.TO.SETTINGS': 'Edit settings',
  'CONTACT.MANAGE.LIST.SEGMENT.SEND.CAMPAIGN': 'Segment them and send campaign',
  'CONTACT.MANAGE.LIST.TOTAL.TIPS':
    '<b class="color-primary">{subscriberTotal}</b> subscribers out of <b class="color-primary">{total}</b> contacts',
  'CONTACT.MANAGE.LIST.QUICK.MODAL.TITLE':
    'Create a segment and send a campaign',
  'CONTACT.MANAGE.LIST.QUICK.MODAL.SAVE': 'Save and send a campaign',
  'CONTACT.MANAGE.LIST.SOURCE.LABEL.MAX.NUM.TIPS':
    'The number of source and label selections exceeds {maxNum}. Please delete and try again',
  'CONTACT.MANAGE.LIST.RECORD': 'Import History',
  'CONTACT.MANAGE.LIST.IMPORT.HISTORY': 'Import history',
  'CONTACT.MANAGE.LIST.EXPORT.HISTORY': 'Export Center',
  'CONTACT.MANAGE.LIST.DEL.HISTORY': 'Delete history',
  'CONTACT.MANAGE.LIST.FIELD.SETTINGS': 'Attribute',
  'CONTACT.MANAGE.LIST.OPT.IN.SETTINGS': 'Import contacts settings',
  'CONTACT.MANAGE.LIST.EXIST.SEGMENT.TITLE':
    'The rules you created already exist',
  'CONTACT.MANAGE.LIST.EXIST.SEGMENT.DESC':
    'Once confirmed, you can use the change rule directly in the filter',
  'CONTACT.MANAGE.LIST.EXIST.SEGMENT.DESC1':
    'Once confirmed, you can find or use the rule in the list',
  'CONTACT.MANAGE.LIST.EXIST.SEGMENT.DESC2':
    'Once confirmed, you will back to the segments page',
  'CONTACT.MANAGE.LIST.TAGS': 'Tags',
  'CONTACT.MANAGE.LIST.SOURCE': 'Source',
  'CONTACT.MANAGE.LIST.SEGMENT': 'Segment',
  'CONTACT.MANAGE.LIST.RESET': 'Reset filters',

  'CONTACT.MANAGE.LIST.ENGAGEMENT.RATING.DESC.TITLE':
    "Engagement is a reflection of the contact's interactions. A high engagement means the contact is frequently interacting.",

  'CONTACT.MANAGE.LIST.DROPDOWN.VISIBLE': 'Select from current page',
  'CONTACT.MANAGE.LIST.DROPDOWN.ALL': 'Select all',
  'CONTACT.MANAGE.LIST.DROPDOWN.NONE': 'Deselect all',
  'CONTACT.MANAGE.LIST.DEL.TITLE': 'Bulk delete contacts',
  'CONTACT.MANAGE.LIST.DEL.DESC.1': "<b class='color-333'>'",
  'CONTACT.MANAGE.LIST.DEL.DESC.2':
    "<b class='color-333'>'</b> contact(s) selected. The selected contact(s) will be permanently deleted and cannot be restored.",
  'CONTACT.MANAGE.LIST.DEL.CONFIRM': 'DELETE',
  'CONTACT.MANAGE.LIST.DEL.LABEL': 'Type <b>DELETE</b> to confirm',
  'CONTACT.MANAGE.LIST.DEL.PROGRESS': 'Deletion progress',
  'CONTACT.MANAGE.LIST.DEL.SUCCESS': 'Successfully deleted {num} contacts',
  'CONTACT.MANAGE.LIST.DEL.MAX':
    'Up to {num} contact information can be selected at a time',
  'CONTACT.MANAGE.LIST.EXPORT.TITLE': 'Export attribute settings',
  'CONTACT.MANAGE.LIST.EXPORT.DESC': 'Select attributes to export',
  'CONTACT.MANAGE.LIST.EXPORT.ATTRIBUTE.NAME': 'Attribute name',
  'CONTACT.MANAGE.LIST.EXPORT.ATTRIBUTE.TYPE': 'Attribute type',
  'CONTACT.MANAGE.LIST.EXPORT.SURE': 'Export',
  'CONTACT.MANAGE.LIST.EXPORT.INFO':
    'Exporting data will take some time. An email will be sent to you when it is completed.',
  'CONTACT.MANAGE.LIST.EXPORT.LIPASS.INFO':
    'Exporting data will take some time. An email will be sent to you when it is completed. Note: contacts added <span class="font-weight-700">exclusively</span> through <span class="font-weight-700">LEVEL INFINITE PASS cannot</span> be exported.',
  'CONTACT.MANAGE.LIST.DETAIL.CHANNELS': 'Channels',
  'CONTACT.MANAGE.LIST.DETAIL.PROFILE': 'Profile',
  'CONTACT.MANAGE.LIST.DETAIL.CHANNELS.EMAIL': 'Email',
  'CONTACT.MANAGE.LIST.DETAIL.CHANNELS.WHATSAPP': 'WhatsApp',

  // 老版本时间线
  'CONTACT.MANAGE.USER.DETAILS': 'User details',
  'CONTACT.MANAGE.DETAIL.TIME.TITLE': 'Time line',
  'CONTACT.MANAGE.TIME.LINE.TIPS.1-FILE':
    '<span class={calssNames}>{operatorOrsource}</span> added new contact using {source}',
  'CONTACT.MANAGE.TIME.LINE.TIPS.1-SINGLE-ADD': 'Contact added manually',
  'CONTACT.MANAGE.TIME.LINE.TIPS.1-API':
    'New contact added by <span>{source}</span>',
  'CONTACT.MANAGE.TIME.LINE.TIPS.1-LI-PASS': 'New contact added by {source}',
  'CONTACT.MANAGE.TIME.LINE.TIPS.2':
    'Source added by <span class={calssNames}>{operatorOrsource}</span>',
  'CONTACT.MANAGE.TIME.LINE.TIPS.3-1':
    '<span class={calssNames}>{operatorOrsource}</span> added a tag',
  'CONTACT.MANAGE.TIME.LINE.TIPS.3-2':
    '<span class={calssNames}>{operatorOrsource}</span> added the <span class="time-line-variable">{name}</span> tag',
  'CONTACT.MANAGE.TIME.LINE.TIPS.4-1-1':
    'Player updated the subscription status to subscribed',
  'CONTACT.MANAGE.TIME.LINE.TIPS.4-1-2':
    '<span class={calssNames}>{operatorOrsource}</span> updated the subscription status to subscribed',
  'CONTACT.MANAGE.TIME.LINE.TIPS.4-2-1':
    'Player updated the subscription status to unsubscribed',
  'CONTACT.MANAGE.TIME.LINE.TIPS.4-2-2':
    '<span class={calssNames}>{operatorOrsource}</span> updated the subscription status to unsubscribed',
  'CONTACT.MANAGE.TIME.LINE.TIPS.4-3-1':
    'Player updated the subscription status to non-subscribed',
  'CONTACT.MANAGE.TIME.LINE.TIPS.4-3-2':
    '<span class={calssNames}>{operatorOrsource}</span> updated the subscription status to non-subscribed',
  'CONTACT.MANAGE.TIME.LINE.TIPS.5':
    '{value} of profile modified by <span class={calssNames}>{operatorOrsource}</span>',
  'CONTACT.MANAGE.TIME.LINE.TIPS.6':
    '<span class={calssNames}>{operatorOrsource}</span> updated the subscription status through the console',
  'CONTACT.MANAGE.TIME.LINE.TIPS.7-1-1':
    'Player subscribed through the landing page.',
  'CONTACT.MANAGE.TIME.LINE.TIPS.7-1-2':
    '<span class={calssNames}>{operatorOrsource}</span> subscribed through the landing page.',
  'CONTACT.MANAGE.TIME.LINE.TIPS.7-2-1':
    'Players updated the subscription status to unsubscribed on the landing page',
  'CONTACT.MANAGE.TIME.LINE.TIPS.7-2-2':
    '<span class={calssNames}>{operatorOrsource}</span> updated the subscription status to unsubscribed on the landing page',
  'CONTACT.MANAGE.TIME.LINE.TIPS.8':
    'Campaign <span class="time-line-variable">{activityName}</span> has been sent to recipients',
  'CONTACT.MANAGE.TIME.LINE.TIPS.9':
    'Email update by <span class={calssNames}>{operatorOrsource}</span>',
  'CONTACT.MANAGE.TIME.LINE.TIPS.10':
    'OpenID update by <span class={calssNames}>{operatorOrsource}</span>',
  'CONTACT.MANAGE.TIME.LINE.TIPS.11':
    'Language updated by <span class={calssNames}>{operatorOrsource}</span>',
  'CONTACT.MANAGE.TIME.LINE.TIPS.12':
    'Region updated by <span class={calssNames}>{operatorOrsource}</span>',
  'CONTACT.MANAGE.TIME.LINE.TIPS.15':
    '<span class={calssNames}>{operatorOrsource}</span> removed the <span class="time-line-variable">{tagName}</span> tag',
  'CONTACT.MANAGE.TIME.LINE.TIPS.16-FILE':
    'Document upload: <span class={calssNames}>{operatorOrsource}</span> added subscription group(s): <span class="time-line-variable">{preference}</span>',
  'CONTACT.MANAGE.TIME.LINE.TIPS.16-SINGLE-ADD':
    'Added manually: <span class={calssNames}>{operatorOrsource}</span> added subscription group(s): <span class="time-line-variable">{preference}</span>',
  'CONTACT.MANAGE.TIME.LINE.TIPS.16-API':
    'API afferent：<span class="time-line-variable">{source}</span> added subscription group(s): <span class="time-line-variable">{preference}</span>',
  'CONTACT.MANAGE.TIME.LINE.TIPS.16-LI-PASS':
    'LEVEL INFINITE PASS afferent：<span class="time-line-variable">{source}</span> added subscription group(s): <span class="time-line-variable">{preference}</span>',
  'CONTACT.MANAGE.TIME.LINE.TIPS.17-FILE':
    'Document upload: <span class={calssNames}>{operatorOrsource}</span> removed subscription group(s): <span class="time-line-variable">{preference}</span>',
  'CONTACT.MANAGE.TIME.LINE.TIPS.17-SINGLE-ADD':
    'Added manually: <span class={calssNames}>{operatorOrsource}</span> removed subscription group(s): <span class="time-line-variable">{preference}</span>',
  'CONTACT.MANAGE.TIME.LINE.TIPS.17-API':
    'API afferent：<span class="time-line-variable">{source}</span> removed subscription group(s): <span class="time-line-variable">{preference}</span>',
  'CONTACT.MANAGE.TIME.LINE.TIPS.17-LI-PASS':
    'LEVEL INFINITE PASS afferent：<span class="time-line-variable">{source}</span> removed subscription group(s): <span class="time-line-variable">{preference}</span>',
  'CONTACT.MANAGE.TIME.LINE.TIPS.18':
    'Player added subscription group(s): <span class="time-line-variable">{addPreference}</span>',
  'CONTACT.MANAGE.TIME.LINE.TIPS.19':
    'Player removed subscription group(s): <span class="time-line-variable">{removePreference}</span>',

  // 时间线 - 涉及变量信息
  'CONTACTS.TIME.LINE.EMAIL': 'email',
  'CONTACTS.TIME.LINE.WHATSAPP': 'WhatsApp',
  'CONTACTS.TIME.LINE.SUBSCRIBE.SURE': 'subscribed successfully',
  'CONTACTS.TIME.LINE.SUBSCRIBE.CANCEL': 'unsubscribed',
  'CONTACTS.TIME.LINE.SUBSCRIBE.RE': 'resubscribed',
  'CONTACTS.TIME.LINE.SUBSCRIBE.PENDING': 'pending',
  'CONTACTS.TIME.LINE.PREFERENCE': 'preferences',
  'CONTACTS.TIME.LINE.TAG': 'tags',
  'CONTACTS.TIME.LINE.LANGUAGE': 'language',
  'CONTACTS.TIME.LINE.REGION': 'region',
  'CONTACT.TIME.LINE.SOURCE.PLAYER': '',
  'CONTACT.TIME.LINE.SOURCE.PLAYER.NAME': 'contact',
  'CONTACTS.TIME.LINE.PUNCTUATION.PAUSE': '; ',
  'CONTACTS.TIME.LINE.PUNCTUATION.PARALLEL': ', ',
  // 时间线 - 新增
  'CONTACTS.TIME.LINE.ADD.BY.CSV':
    '<span class="time-line-variable">{operator}</span> imported <span class="time-line-variable">{channelValue}</span> through CSV',
  'CONTACTS.TIME.LINE.ADD.BY.MANUAL':
    '<span class="time-line-variable">{operator}</span> imported contact individually',
  'CONTACTS.TIME.LINE.ADD.BY.API':
    'Imported <span class="time-line-variable">{channelValue}</span> via API <span class="time-line-variable">{channelName}</span>',
  'CONTACTS.TIME.LINE.ADD.BY.FORM':
    'Imported email through form <span class="time-line-variable">{formName}</span>',
  'CONTACTS.TIME.LINE.ADD.BY.OTHER':
    'Imported <span class="time-line-variable">{source}</span> via <span class="time-line-variable">{channelValue}</span> ',
  // 时间线 - 关联
  'CONTACTS.TIME.LINE.LINK.BY.USER':
    '<span class="time-line-variable">{operator}</span> updated <span class="time-line-variable">{channelValue}</span> through {source}',
  'CONTACTS.TIME.LINE.LINK.BY.OTHER':
    '<span class="time-line-variable">{source}</span> updated contact information <span class="time-line-variable">{channelValue}</span>',
  // 时间线 - 整合
  'CONTACTS.TIME.LINE.INTEGRATE.CHANNELS':
    'Linked email <span class="time-line-variable">{email}</span> and WhatsApp <span class="time-line-variable">{wuid}</span> for contact',
  // 时间线 - 更新
  'CONTACTS.TIME.LINE.CONTACTS.INFO.UPDATE.BY.USER':
    '<span class="time-line-variable">{operator}</span> updated contact information through source <span class="time-line-variable">{source}</span>',
  'CONTACTS.TIME.LINE.CONTACTS.INFO.UPDATE.BY.API':
    'API <span class="time-line-variable">{channelName}</span> updated contact information',
  'CONTACTS.TIME.LINE.CONTACTS.INFO.UPDATE.BY.FORM':
    'Updated contact information through form <span class="time-line-variable">{formName}</span>',
  'CONTACTS.TIME.LINE.CONTACTS.INFO.UPDATE.BY.DETAILS':
    "<span class='time-line-variable'>{operator}</span> updated information on the 'Contact details' page",
  'CONTACTS.TIME.LINE.CONTACTS.INFO.UPDATE.BY.OTHER':
    '<span class="time-line-variable">{source}</span> updated contact information',
  'CONTACTS.TIME.LINE.CONTACTS.INFO.UPDATE.BY.DISCORD':
    'Contact binds <b class="time-line-variable">Discord</b> account:',
  'CONTACTS.TIME.LINE.CONTACTS.INFO.UPDATE.BY.STEAM':
    'Contact binds <b class="time-line-variable">Steam</b> account:',
  'CONTACTS.TIME.LINE.INVITED.TO.TEST.TITLE':
    'Contact is invited to join <b class="time-line-variable">{journeyName}</b>',
  // 时间线 - 订阅状态
  'CONTACTS.TIME.LINE.SUB.SURE':
    'Contact <span class="time-line-variable">{subscribe}</span>',
  'CONTACTS.TIME.LINE.SUB.ADD':
    'Added {channelName} subscription status: <span class="time-line-variable">{subscribe}</span>',
  'CONTACTS.TIME.LINE.SUB.UPDATED':
    'Updated {channelName} subscription status: <span class="time-line-variable">{subscribe}</span>',
  'CONTACTS.TIME.LINE.SUB.UPDATED.FORM.TO':
    'Updated {channelName} subscription status from <span class="time-line-variable">{oldSubscribe}</span> to <span class="time-line-variable">{newSubscribe}</span>',
  'CONTACTS.TIME.LINE.SUB.UPDATED.IN.ACTIVITY':
    '<span class="time-line-variable">{newSubscribe}</span> email from campaign',
  'CONTACTS.TIME.LINE.SUB.UPDATED.FORM.TO.IN.JOURNEY.NODE':
    '<span class="time-line-variable">{subscribe}</span> email from journey <span class="time-line-variable">{journeyName}</span> and journey point <span class="time-line-variable">{nodeName}</span>',
  // 时间线 - 字段
  'CONTACTS.TIME.LINE.FILED.ADD':
    'Added {filedName}: <span class="time-line-variable">{value}',
  'CONTACTS.TIME.LINE.FILED.UPDATE':
    'Updated {filedName}: <span class="time-line-variable">{value}</span>',
  'CONTACTS.TIME.LINE.BIND.TAGS':
    'Updated tags: <span class="time-line-variable">{value}</span>',
  'CONTACTS.TIME.LINE.UNBIND.TAGS':
    'Deleted tags: <span class="time-line-variable">{value}</span>',
  'CONTACTS.TIME.LINE.PREFERENCE.ADD':
    'Added preferences: <span class="time-line-variable">{value}</span>',
  'CONTACTS.TIME.LINE.PREFERENCE.REMOVE':
    'Deleted preferences: <span class="time-line-variable">{value}</span>',
  'CONTACTS.TIME.LINE.WAHTSAPP.INFERRED':
    "Contact's {filedName} not found in import. Region set to <span class='time-line-variable'>{areaCode}</span>, according to area code <span class='time-line-variable'>{value}</span>",
  // 时间线 - 活动
  'CONTACTS.TIME.LINE.CLICK.ACTIVITY.LINK.BY.WHATSAPP':
    'Clicked on link <span class="time-line-variable" title={hoverLinkUrl}>{showLinkUrl}</span> in campaign <span class="time-line-variable">{activityName}</span>',
  'CONTACTS.TIME.LINE.CLICK.ACTIVITY.LINK.BY.EMAIL':
    'Clicked on link <span class="time-line-variable" title={hoverLinkUrl}>{showLinkUrl}</span> in campaign <span class="time-line-variable">{activityName}</span>',
  'CONTACTS.TIME.LINE.OPEN.ACTIVITY.BY.EMAIL':
    'Opened email from campaign <span class="time-line-variable">{activityName}</span>',
  'CONTACTS.TIME.LINE.SUBMIT.ACTIVITY.BY.EMAIL':
    'Submitted form <span class="time-line-variable">{formName}</span> in campaign <span class="time-line-variable">{activityName}</span>',
  'CONTACTS.TIME.LINE.READED.ACTIVITY.BY.WHATSAPP':
    'Read message from campaign <span class="time-line-variable">{activityName}</span>',
  // 时间线 - 旅程
  'CONTACTS.TIME.LINE.CLICK.JOURNEY.NODE.LINK.BY.EMAIL':
    'Clicked on link <span class="time-line-variable" title={hoverLinkUrl}>{showLinkUrl}</span> in email from journey <span class="time-line-variable">{journeyName}</span> and journey point <span class="time-line-variable">{nodeName}</span>',
  'CONTACTS.TIME.LINE.OPEN.JOURNEY.NODE.BY.EMAIL':
    'Opened email from journey <span class="time-line-variable">{journeyName}</span> and journey point <span class="time-line-variable">{nodeName}</span>',
  'CONTACTS.TIME.LINE.FILLIN.JOURNEY.NODE.FORM':
    'Submitted form <span class="time-line-variable">{formName}</span> in email from journey <span class="time-line-variable">{journeyName}</span> and journey point <span class="time-line-variable">{nodeName}</span>',
  'CONTACTS.TIME.LINE.ENTRY.JOURNEY':
    'Entered journey <span class="time-line-variable">{journeyName}</span>',
  'CONTACTS.TIME.LINE.COMPLETED.JOURNEY':
    'Completed journey <span class="time-line-variable">{journeyName}</span>',
  // 时间线 - 投递（活动&旅程）
  'CONTACTS.TIME.LINE.ACTIVITY.DELIVERY.EMAIL':
    'Sent email from campaign <span class="time-line-variable">{activityName}</span>',
  'CONTACTS.TIME.LINE.ACTIVITY.DELIVERY.WAHTSAPP':
    'Sent WhatsApp message from <span class="time-line-variable">{activityName}</span>',
  'CONTACTS.TIME.LINE.DOUBLEOPTIN.RECEIVED.EMAIL':
    'Sent <span class="time-line-variable">double opt-in email</span>',
  'CONTACTS.TIME.LINE.JOURNEY.NODE.DELIVERED.EMAIL':
    'Sent email from journey <span class="time-line-variable">{journeyName}</span> and journey point <span class="time-line-variable">{nodeName}</span>',

  // 时间线 - 其他操作
  'CONTACTS.TIME.LINE.DISCORD.BIND.CONTENT.ADD':
    '<p>New Discord ID: <b class="time-line-variable">{DiscordId}</b></p>',
  'CONTACTS.TIME.LINE.DISCORD.BIND.CONTENT.UPDATE':
    '<p>Updated Discord ID: <b class="time-line-variable">{DiscordId}</b></p>',
  'CONTACTS.TIME.LINE.BIND.CONTENT.EMAIL.ADD':
    '<p>New account email: <b class="time-line-variable">{Email}</b></p>',
  'CONTACTS.TIME.LINE.BIND.CONTENT.EMAIL.UPDATE':
    '<p>Updated account email: <b class="time-line-variable">{Email}</b></p>',
  'CONTACTS.TIME.LINE.BIND.CONTENT.NICKNAME.ADD':
    '<p>New nickname: <b class="time-line-variable">{userName}</b></p>',
  'CONTACTS.TIME.LINE.BIND.CONTENT.NICKNAME.UPDATE':
    '<p>Updated nickname: <b class="time-line-variable">{userName}</b></p>',
  'CONTACTS.TIME.LINE.DISCORD.BIND.CONTENT.SERVER.ADD':
    '<p>Contact joins Discord server: <b class="time-line-variable">{ServerName} #{ChannelName}</b></p>',
  'CONTACTS.TIME.LINE.DISCORD.BIND.CONTENT.SERVER.UPDATE':
    '<p>Updated joins Discord server: <b class="time-line-variable">{ServerName} #{ChannelName}</b></p>',
  'CONTACTS.TIME.LINE.STEAM.BIND.CONTENT.ADD': `<p>New Steam ID: <b class="time-line-variable">{SteamId}</b></p>`,
  'CONTACTS.TIME.LINE.STEAM.BIND.CONTENT.UPDATE': `<p>Updated Steam ID: <b class="time-line-variable">{SteamId}</b></p>`,
  'CONTACTS.TIME.LINE.STEAM.BIND.CONTENT.EMAIL': `<p>New account email: <b class="time-line-variable">{Email}</b></p>`,
  'CONTACTS.TIME.LINE.INVITED.TO.TEST1.CONTENT':
    '<p>Email sent from the Custom Sending Node of the Invitation Journey: <b class="time-line-variable">{testerList}</b></p>',
  'CONTACTS.TIME.LINE.INVITED.TO.TEST2.CONTENT':
    '<p>Contact accepts the invitation</p>',
  'CONTACTS.TIME.LINE.DISCORD.CONTACT.MERGE':
    '<b class="time-line-variable">Contact merged: {Email}</b> linked to Discord account (Discord ID：<b>{DiscordId}</b>)',
  'CONTACTS.TIME.LINE.STEAM.CONTACT.MERGE':
    '<b class="time-line-variable">Contact merged: {Email}</b> linked to Steam account (Steam ID：<b>{SteamId}</b>)',

  // 上传excel - 来源
  'CONTACT.MANAGE.CREATE.SOURCE.TITLE': 'Source',
  'CONTACT.MANAGE.CREATE.SOURCE.DESC': 'Select source to import contacts from',
  'CONTACT.MANAGE.CREATE.SOURCE.UPLOAD.LABEL': 'Import CSV file',
  'CONTACT.MANAGE.CREATE.SOURCE.UPLOAD.LABEL.EXTRA':
    'Select a csv file from your computer',
  'CONTACT.MANAGE.CREATE.SOURCE.WHATSAPP.UPLOAD.LABEL.EXTRA':
    'Emails and WhatsApp numbers can be imported via CSV.',
  'CONTACT.MANAGE.CREATE.SOURCE.WHATSAPP.UPLOAD.LABEL.EXTRA.TIPS':
    'CSV supports importing WhatsApp numbers. (importing WhatsApp numbers is not supported through other methods for the time being)',
  'CONTACT.MANAGE.CREATE.SOURCE.API.LABEL': 'Import via API',
  'CONTACT.MANAGE.CREATE.SOURCE.API.LABEL.DESC':
    'For more information, see Import via API',
  'CONTACT.MANAGE.CREATE.SOURCE.UPLOAD.LABEL.EXTRA.L': 'Please go to the',
  'CONTACT.MANAGE.CREATE.SOURCE.UPLOAD.LABEL.EXTRA.C': 'document center',
  'CONTACT.MANAGE.CREATE.SOURCE.UPLOAD.LABEL.EXTRA.R': 'to view the documents',
  'CONTACT.MANAGE.CREATE.SOURCE.ADD.A.SUBS.LABEL': 'Import individual contact',
  'CONTACT.MANAGE.CREATE.SOURCE.ADD.A.SUBS.LABEL.EXTRA': 'Fill in a contact',
  'CONTACT.MANAGE.CREATE.SOURCE.ADD.LIPASS.LABEL': 'LEVEL INFINITE PASS',
  'CONTACT.MANAGE.CREATE.SOURCE.ADD.LIPASS.LABEL.EXTRA':
    'Synchronize player data from LEVEL INFINITE PASS to Contacts in SmartLink',
  'CONTACT.MANAGE.CREATE.SOURCE.ADD.WHITE.LABEL.EXTRA':
    'Synchronize player data from {title} to Contacts in SmartLink',
  'CONTACT.MANAGE.CREATE.SOURCE.ADD.LIPASS.AUTHORISED': 'Authorised',
  'CONTACT.MANAGE.CREATE.SOURCE.ADD.LIPASS.NOT.AUTHORISED': 'Unauthorised',
  'CONTACT.MANAGE.CREATE.SOURCE.THIRD.PART.PLATFORMS':
    'From third-party platforms',
  'CONTACT.MANAGE.CREATE.SOURCE.NEWSLETTER.LABEL': 'Newsletter sign-up',
  'CONTACT.MANAGE.CREATE.SOURCE.NEWSLETTER.LABEL.EXTRA':
    'From LEVEL INFINITE PASS	',
  'CONTACT.MANAGE.CREATE.SOURCE.NEWSLETTER.ON': 'ON',
  'CONTACT.MANAGE.CREATE.SOURCE.NEWSLETTER.OFF': 'OFF',

  // 联系人上传文件
  'CONTACT.MANAGE.CREATE.ADD.CONTACTS': 'Import contact(s)',
  'CONTACT.MANAGE.CREATE.ADD.CONTACTS.UPLOAD.DIS':
    'Up to { num } files in a single upload',
  'CONTACT.MANAGE.CREATE.ADD.CONTACTS.DROP.FILES':
    'Select your file or drag and drop it here',
  'CONTACT.MANAGE.CREATE.ADD.CONTACTS.DROP.FILES.LIMIT':
    'Only the CSV format is supported, up to 20MB per file.',
  'CONTACT.MANAGE.CREATE.ADD.CONTACTS.DROP.FILES.DECODE':
    'File needs to be encoded in UTF-8 format',
  'CONTACT.MANAGE.CREATE.ADD.CONTACTS.UPLOADING': 'Uploading your file',
  'CONTACT.MANAGE.CREATE.ADD.CONTACTS.UPLOADED': 'Your file has been uploaded!',
  'CONTACT.MANAGE.CREATE.ADD.CONTACTS.DOWNLOAD.SAMPLE.NAME':
    'ContactUploadTemplate',
  'CONTACT.MANAGE.CREATE.SOURCE.CONTINUR': 'Continue',
  'CONTACT.MANAGE.CREATE.SOURCE.GO.SETTING': 'Go',
  'CONTACT.MANAGE.CREATE.SOURCE.MATCH.CONTINUR.TIPS':
    'No emails found,please check your file.',
  'CONTACT.MANAGE.CREATE.SOURCE.MATCH.CONTINUR.WHATSAPP.TIPS':
    'No emails or whatsApp found,please check your file.',
  'CONTACT.MANAGE.CREATE.SOURCE.PREVIOUE': 'Previous',
  'CONTACT.MANAGE.CREATE.SOURCE.VIEW.API': 'View API Reference',
  'CONTACT.MANAGE.CREATE.SOURCE.PERCENT': 'Data reading ({percent}%)',
  'CONTACT.MANAGE.CREATE.SOURCE.COMPLETE': 'Confirm import',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD': 'Upload file',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.MACH': 'Match attribute',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPDATE.CONTACTS': 'Update contacts',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.STATUS': 'Subscription status',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.PREFERENCE': 'Preferences',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.TAG': 'Tags',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW': 'Review',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.TITLE': 'Upload your file',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.CODE': 'Region & language codes',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.WHATSAPP.CODE':
    'WhatsApp Country Code & Country Mapping',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.EXAMPLE':
    'Download CSV file template',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.INFO.DESC.1':
    'Upload a file to batch import contacts, including all relevant personal information.',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.INFO.DESC.2':
    'It is recommended to import all system fields, these can still be edited later.',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.INFO.NORM':
    'System field specifications',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.INFO.RL.TITLE': 'Region & Language',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.INFO.RL.1':
    'To import regions and languages, check the region and language codes and fill in the corresponding codes in the CSV file.',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.WHATSAPP.UPLOAD.INFO.RL.1':
    'When imported WhatsApp numbers lack regional data, the system automatically applies this mapping to assign corresponding country attributes to contacts.',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.INFO.TP.TITLE':
    'Tags / Preferences / Drop down',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.INFO.TP.1':
    'Tags, preferences and drop down options can only accept values that have already been created in SmartLink.',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.INFO.TP.2':
    '· When adding multiple tags, preferences or drop down values to a single contact, use ";" or "|" as a separator.',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.INFO.TP.3':
    "· In the first row of the CSV file, these attributes can be named 'Preferences' and 'Tags'.",
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.INFO.DT.TITLE': 'Date & Time',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.INFO.DT.1':
    'Date fields must include the time zone, and only the 2 formats below are supported',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.INFO.1':
    'This upload will update the contact information in the contact list, excluding the subscription status.',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.INFO.2':
    'For each contact, in addition to the email address, language and region, you can include other properties (name, surname, birthday, gender, etc,).',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.INFO.3':
    'Date attributes must include the time zone, and only the following two formats are supported:',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.INFO.4':
    '<span class="contact-upload-info-time">· 2001-03-07+08:00</span><span class="contact-upload-info-time">· 2001-03-07 00:00:00+08:00</span>',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.INFO.5':
    'Preferences and Tags can only accept values that have already been created in SmartLink.',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.INFO.6':
    '· In the top row of the CSV file, these attributes can be named "Preferences" and "Tags".',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.INFO.7':
    '· When adding multiple preferences or tags to a single contact, use "|" as a seperator.',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.INFO.8':
    'The imported contact information can be used to segment your contacts and to customize your campaigns!',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.CHANGE.HEADER.CREATE':
    'Create a new attribute',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.CHANGE.HEADER.PROPETRY':
    'attribute',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.CHANGE.HEADER.PROPETRY.MSG':
    'Invalid attribute format',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.CHANGE.HEADER.PROPETRY.MSG.RPT':
    'The attribute cannot be the same as an existing header',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.CHANGE.HEADER.PROPETRY.HOLDER':
    'Enter a name',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.CHANGE.HEADER.TYPE': 'Type',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.CHANGE.HEADER.TYPE.MSG':
    'Please select the type',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.FILED.LIMIT.SIZE':
    'The file to upload cannot exceed 20 MB',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.FILED.LIMIT.NAME.LENGTH':
    'Filename too long, please keep length to within 255 characters',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.FILED.LIMIT.NUM':
    'Do not upload more than {num} files',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.FILED.MSG': 'File upload error',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.FILED.MSG.TYPE':
    'Please upload a CSV file',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.MACH.STAT':
    '<span class={importClass}>{passNum}</span> columns will be imported. <span class={unImportClass}>{unPassNum}</span> columns will not be imported.',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.MACH.TEADER.INFO':
    'This column cannot be imported. Select an existing attribute or add a new attribute to import this column.',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.MACH.FILED.USED': 'Already used',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.TAG.TITLE': 'Organize your contacts',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.TAG.SUB': 'Select subscription status',
  'CONTACT.MANAGE.CREATE.SOURCE.EMAIL.FILE.TAG.SUB.TITLE':
    'Email Subscription Status Settings',
  'CONTACT.MANAGE.CREATE.SOURCE.WHATSAPP.FILE.TAG.SUB.TITLE':
    'WhatsApp Subscription Status Settings',
  'CONTACT.MANAGE.CREATE.SOURCE.EMAIL.FILE.TAG.SUB':
    'Email subscription status',
  'CONTACT.MANAGE.CREATE.SOURCE.WHATSAPP.FILE.TAG.SUB':
    'WhatsApp subscription status',
  'CONTACT.MANAGE.CREATE.SOURCE.SUB.STATUS.NOT.SET': 'Not Configured',
  'CONTACT.MANAGE.CREATE.SOURCE.SUB.STATUS.SET': '‌Configured',
  'CONTACT.MANAGE.CREATE.SOURCE.SUB.STATUS.AUTO': 'Auto-configured',
  // 'CONTACT.MANAGE.CREATE.SOURCE.FILE.TAG.UPDATE.EXTRA':
  //   'lf we spot a duplicate emil in your import, well automatically replace the existing oontact information with the new data.',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.TAG.CREATE': 'Search for or create tags',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.TAG.CREATE.DESC':
    'Emails can be sent directly to contacts associated with this tag, and segments related to this tag can be created.',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.TAG.SUB.1.AND.4':
    'This will not update the subscription status of existing contacts',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.TAG.SUB.1': 'Subscribed',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.TAG.SUB.RECOM': 'Suggested',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.TAG.SUB.1.DESC':
    'Mark all imported contacts, excluding those already in the system, as subscribed. Contact information, besides subscription status, is updated for all contacts based on the imported list.',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.WHATSAPP.TAG.SUB.1.DESC':
    'New WhatsApp contacts: Auto subscribed Existing unsubscribed: Status preserved',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.TAG.SUB.1.EXTRA':
    'Selecting the "Subscribed" status means that you have obtained permission to send emails to these contacts. Learn more about \'<a href="{url}" target="_blank">obtaining permission</a>\'.',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.WHATSAPP.TAG.SUB.1.EXTRA':
    'When you select the "Subscribed" status, it means you have obtained permission to send WhatsApp messages to them. Learn more about \'<a href="{url}" target="_blank">obtaining permission</a>\'.',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.WHATSAPP.TAG.SUB.0.EXTRA':
    'The campaign cannot send messages to "Unsubscribed" contacts, so please choose carefully.',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.WHATSAPP.TAG.SUB.-1.EXTRA':
    'The campaign cannot send messages to "Unknown" contacts. The "Unknown" status can be updated through subsequent import of contact information, etc.',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.TAG.SUB.1.OPTIONS.1':
    'Update the subscription status of existing contacts',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.TAG.SUB.1.OPTIONS.2':
    'Update the subscription status of existing contacts, except for unsubscribed contacts',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.TAG.SUB.1.OPTIONS.3':
    'Do not update the subscription status of existing contacts',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.TAG.SUB.2.DESC':
    'Without importing contacts that are already in the system, import all other contacts and mark their subscription status as subscribed.',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.TAG.SUB.2.EXTRA':
    'Without importing contacts that are already in the system, import all other contacts and mark their subscription status as subscribed.',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.TAG.SUB.2.OPTIONS.1':
    'Update the subscription status of existing contacts',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.TAG.SUB.3.DESC':
    'Without considering existing contacts in the system, import all contacts and mark their subscription status as subscribed.',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.TAG.SUB.3.EXTRA':
    'Without considering existing contacts in the system, import all contacts and mark their subscription status as subscribed.',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.TAG.SUB.4': 'Unsubscribed',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.TAG.SUB.4.DESC':
    'Without considering existing contacts in the system, import all contacts and mark their subscription status as unsubscribed.',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.TAG.SUB.4.EXTRA':
    "Campaigns typically cannot send emails to 'unsubscribed' contacts. However, when contacts are selected without regards to their subscription status, emails can be sent to 'unsubscribed' contacts.",
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.TAG.SUB.5': 'Non-subscribed',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.TAG.SUB.5.DESC':
    'Without considering existing contacts in the system, import all contacts and mark their subscription status as non-subscribed.',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.TAG.SUB.5.EXTRA':
    "Campaigns typically cannot send emails to 'Non-subscribed' contacts. However, when contacts are selected without regards to their subscription status, emails can be sent to 'Non-subscribed' contacts. The 'Non-subscribed' status can be updated by importing your list of contacts another time.",
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.STATUS.PREFERENCES.LABEL':
    'Set preferences for contacts',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.STATUS.PREFERENCES.EXTRA':
    "Please set preferences in advance under 'Contacts' -> 'Preferences'",
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.STATUS.UPDATE.CHECKBOX.LABEL':
    'Update existing contacts',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.STATUS.UPDATE.CHECKBOX.EXTRA':
    'If an imported contact is already in your contacts list, their information will be replaced with the imported data. Ticking this option may prolong the duration of the import.',
  'CONTACT.MANAGE.CREATE.WHATSAPP.SOURCE.FILE.STATUS.UPDATE.CHECKBOX.EXTRA':
    '1.If imported Email/WhatsApp contacts already exist, the system will automatically overwrite the original data with new information (selecting this option will increase import time).<p class="pt-10">2.This setting does not affect direct updating of WhatsApp or Email contacts.</p>',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.TAG.CREATE.BTN': 'Create',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.TAG.LIMIT.NUM':
    'Up to {num} tags can be added',

  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.TITLE':
    'Review and confirm your import',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.TAGS': 'Tagged',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.SUB': 'Email marketing status',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.EMAIL.SUB': '邮箱订阅状态',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.WHATSAPP.SUB': 'WhatsApp订阅状态',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.TOTAL': 'Total',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.SUCCESS': 'Succeeded',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.EXCEPTION': 'Failed',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.EXCEPTION.LOGS.DOWN':
    "Download 'Fail log'",
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.EXCEPTION.LOGS.EMAIL.NOT.FOUND':
    'Invalid email address - not found',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.EXCEPTION.LOGS.INVALID.EMAIL':
    'Invalid email address - Invalid format',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.EXCEPTION.LOGS.REPEACT.EMAIL':
    'Duplicate email address',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.EXCEPTION.LOGS.INVALID.LOCATION':
    'Invalid region code',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.EXCEPTION.LOGS.INVALID.LANGUAGE':
    'Invalid language code',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.EXCEPTION.LOGS.INVALID.PREFERENCE':
    'Invalid preference',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.EXCEPTION.LOGS.INVALID.TAG':
    'Invalid tag',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.EXCEPTION.LOGS.INVALID.TAG.TOTAL':
    'Number of tags exceeds the limit, a maximum of {tagMaxNum} tags can be added to a single contact.',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.EXCEPTION.LOGS.EMAIL.DOMIAN.ERROR':
    'Invalid email address - invalid email domain',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.EXCEPTION.LOGS.INVALID.DROPDOWN':
    'Invalid {name}',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.EXCEPTION.LOGS.INVALID.TYPE':
    'Invalid {name} - Invalid format',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.EXCEPTION.LOGS.NOT.REQUIRE.FIELD':
    'Mandatory field is empty',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.EXCEPTION.LOGS.WHATSAPP.INVALID':
    'Invalid WhatsApp number - Invalid format',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.EXCEPTION.LOGS.WHATSAPP.REPEAT':
    'Duplicate WhatsApp number',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.EXCEPTION.INVALID.EMAIL.NOT.FOUND':
    '{num} row(s) without email address',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.EXCEPTION.INVALID.EMAIL':
    '{num} row(s) with invalid email address',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.EXCEPTION.REPEACT.EMAIL':
    '{num} row(s) with with duplicate email address',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.EXCEPTION.INVALID.LOCATION':
    '{num} row(s) with invalid region code',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.EXCEPTION.INVALID.LANGUAGE':
    '{num} row(s) with invalid language code',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.EXCEPTION.INVALID.PREFERENCE':
    '{num} row(s) with invalid preferences',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.EXCEPTION.INVALID.TAG':
    '{num} row(s) with invalid tags',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.EXCEPTION.INVALID.TAG.TOTAL':
    '{num} row(s) number of tags exceeds the limit',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.EXCEPTION.INVALID.TYPE':
    '{num} row(s) with invalid type',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.EXCEPTION.INVALID.DROPDOWN':
    '{num} row(s) with invalid {name}',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.EXCEPTION.INVALID.EMAIL.DOMIAN.ERROR':
    '{num} row(s) with invalid email domain',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.EXCEPTION.NOT.REQUIRE.FIELD':
    '{num} row(s) with empty mandatory field',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.EXCEPTION.WHATSAPP.INVALID':
    '{num} row(s) with invalid WhatsApp number',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.EXCEPTION.WHATSAPP.REPEAT':
    '{num} row(s) with duplicate WhatsApp number',
  // 'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.CONFIRM.IMPORT.LABEL':
  //   'I confirm that my new import adheres to these conditions',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.CONFIRM.IMPORT':
    'I confirm this import complies to the following criteria:',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.CONFIRM.IMPORT.EXTRA.1':
    'In the past 2 years, my contacts have explicitly given me permission or have requested to send them emails/newsletters.',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.CONFIRM.IMPORT.EXTRA.2':
    'These contacts are not borrowed from a third party.',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.CONFIRM.IMPORT.EXTRA.3':
    'These contacts are not purchased or borrowed.',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.REVIEW.CONFIRM.IMPORT.EXTRA.4':
    'We may suspend or cancel any campaigns sent to contacts who do not meet the criteria above at any time.',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.QUIT.TITLE':
    'Exit importing contacts',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.QUIT.DESC':
    'Uploaded data will be lost if you leave without saving.',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.READFILE.HEADER.MSG':
    'Table header cannot be empty',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.READFILE.MSG':
    'Data parsing failed',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.ANALYZE.MSG': 'File parsing error',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.UPLOAD.NO.DATA':
    'No data, please fill in the data before uploading',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.MORE.INFO':
    '<a href="{ url }" target="_blank">More information</a>',
  // 联系人列表数据入库进度
  'CONTACT.MANAGE.PROGRESS.LI':
    'Importing contacts from LEVEL INFINITE PASS ({progress}%)',
  'CONTACT.MANAGE.PROGRESS.FILE': 'Importing contacts ({progress}%)',
  'CONTACT.MANAGE.PROGRESS.UPLOADED': '{count} contacts uploaded',
  'CONTACT.MANAGE.PROGRESS.NAME.UPLOADED': '{name} {count} contacts uploaded',
  'CONTACT.MANAGE.PROGRESS.FILE.IPLOADING': 'Importing {num} contacts...',
  'CONTACT.MANAGE.CREATE.SUB.LIMIT.RADIUS':
    'Number range-9223372036854775808 ~ 9223372036854775807',
  // 地点编码选择弹窗
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.LOCATION.CODE.TIPS':
    'SmartLink has detected a column with region codes in your uploaded file',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.LOCATION.CODE.LABEL':
    'Select the ISO code used in your upload file',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.LOCATION.CODE.THREE.DIGIT': 'Numeric',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.LOCATION.CODE.THREE.DIGIT.TIPS':
    'E.g. “004”',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.LOCATION.CODE.TWO.LETTER': 'Alpha-2',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.LOCATION.CODE.TWO.LETTER.TIPS':
    'E.g. “AF”',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.LOCATION.CODE.THREE.LETTER': 'Alpha-3',
  'CONTACT.MANAGE.CREATE.SOURCE.FILE.LOCATION.CODE.THREE.LETTER.TIPS':
    'E.g. “AFG”',

  // 手动上传单个联系人
  'CONTACT.MANAGE.CREATE.ADD.CONTACTS.ALLOW.SEND.EMAIL':
    'I have obtained explicit consent from all my contacts to send them messages',
  'CONTACT.MANAGE.CREATE.ADD.CONTACTS.UPDATE.EAMIL.INFO':
    'If this person is already in my contacts, update their profile (regardless of subscription status)',
  'CONTACT.MANAGE.CREATE.SUB.DESC.TITLE':
    "You can fill in your contact's <br />information below.",
  'CONTACT.MANAGE.CREATE.SUB.DESC.SMALL1':
    ' If you need to add more attributes, you can go to the ',
  'CONTACT.MANAGE.CREATE.SUB.DESC.SMALL2': 'Attribute',
  'CONTACT.MANAGE.CREATE.SUB.DESC.SMALL3': ' page.',
  'CONTACT.MANAGE.CREATE.SUB.EMAIL.LABEL': 'Email Address',
  'CONTACT.MANAGE.CREATE.SUB.EMAIL.PLACEHOLDER': 'Enter the email address',
  'CONTACT.MANAGE.CREATE.SUB.EMAIL.ERROR': 'Invalid email format',
  'CONTACT.MANAGE.CREATE.SUB.EMAIL.VALIDATOR.ERROR': 'Invalid email domain',
  'CONTACT.MANAGE.CREATE.SUB.EMAIL.TAG.EMPTY': 'Go to create tags',
  'CONTACT.MANAGE.CREATE.SUB.LIMIT.LENGTH':
    'Enter the {name}, up to 1000 characters',

  // 预约设置
  'CONTACT.MANAGE.CREATE.NEWSLETTER.SETTING.TITLE': 'Newsletter settings',
  'CONTACT.MANAGE.CREATE.NEWSLETTER.SETTING.DETAILS': 'Setting details',
  'CONTACT.MANAGE.CREATE.NEWSLETTER.SETTING.SWITCH': 'Enable / Disable',
  'CONTACT.MANAGE.CREATE.NEWSLETTER.SETTING.SWITCH.INFO.1':
    'When enabled, players subscribing to the LEVEL INFINITE PASS website will be imported into SmartLink. ',
  'CONTACT.MANAGE.CREATE.NEWSLETTER.SETTING.SWITCH.INFO.2':
    '<a href="{url}" target="_blank">Learn more</a>',
  'CONTACT.MANAGE.CREATE.NEWSLETTER.SETTING.EMAIL': 'Welcome email settings',
  'CONTACT.MANAGE.CREATE.NEWSLETTER.SETTING.EMAIL.INFO.1':
    'When enabled, players subscribing to the LEVEL INFINITE PASS website will receive a welcome email.',
  'CONTACT.MANAGE.CREATE.NEWSLETTER.SETTING.EMAIL.SENDER.INFO':
    'Sender information',
  'CONTACT.MANAGE.CREATE.NEWSLETTER.SETTING.EMAIL.CONTENT': 'Content',
  'CONTACT.MANAGE.CREATE.NEWSLETTER.SETTING.EMAIL.DEFAULT.LANGUAGE':
    'Default language',
  'CONTACT.MANAGE.CREATE.NEWSLETTER.SETTING.EMAIL.SUBJECT': 'Subject',
  'CONTACT.MANAGE.CREATE.NEWSLETTER.SETTING.EMAIL.SUBJECT.PLACEHOLDER':
    'Enter the subject',
  'CONTACT.MANAGE.CREATE.NEWSLETTER.SETTING.EMAIL.FORM': 'From',
  'CONTACT.MANAGE.CREATE.NEWSLETTER.SETTING.EMAIL.TEMPLATE': 'Email template',
  'CONTACT.MANAGE.CREATE.NEWSLETTER.SETTING.EMAIL.TEMPLATE.PLACEHOLDER':
    'Select a template',
  'CONTACT.MANAGE.CREATE.NEWSLETTER.SETTING.EMAIL.PREVIEW': 'Preview',
  'CONTACT.MANAGE.CREATE.NEWSLETTER.SETTING.EMAIL.PREVIEW.NONE':
    'Select a template',
  'CONTACT.MANAGE.CREATE.NEWSLETTER.SETTING.EMAIL.SEND.TEST': 'Send test email',
  'CONTACT.MANAGE.CREATE.NEWSLETTER.SETTING.EMAIL.SEND.TITLE':
    'Add email addresses to receive test welcome email',
  'CONTACT.MANAGE.CREATE.NEWSLETTER.SETTING.EMAIL.SEND.ADD.EMAIL':
    'Add email addresses manually',
  'CONTACT.MANAGE.CREATE.NEWSLETTER.SETTING.EMAIL.SEND.ADD.EMAIL.PLACEHOLDER':
    'Add 1 email address per row',
  'CONTACT.MANAGE.CREATE.NEWSLETTER.SETTING.EMAIL.SEND.STATISTICS':
    '<span class={colorError}>{num}</span>/{maxNum} emails',
  'CONTACT.MANAGE.CREATE.NEWSLETTER.SETTING.EMAIL.SEND': 'Send',
  'CONTACT.MANAGE.CREATE.NEWSLETTER.SETTING.EMAIL.RETURN.INTERCEPT.TITLE':
    'Return to previous page?',
  'CONTACT.MANAGE.CREATE.NEWSLETTER.SETTING.EMAIL.RETURN.INTERCEPT.DESC':
    'Changes will not be saved',
  'CONTACT.MANAGE.CREATE.NEWSLETTER.SETTING.EMAIL.CONTENT.ERROR.MSG':
    'Please check that the {lang} language content is correct',

  // 标签
  'CONTACT.MANAGE.CREATE.ADD.TAGS.TITLE': 'Add Tags',
  'CONTACT.MANAGE.CREATE.ADD.TAGS.DESC': 'New tags can be created in [Tags].',
  'CONTACT.MANAGE.CREATE.ADD.TAGS.CARD.TITLE':
    'You can send emails directly to contacts associated with the selected tags or create related segments. ',
  'CONTACT.MANAGE.CREATE.ADD.TAGS.CARD.PLACEHOLSER':
    'Here are the tags you have selected for your contacts',
  'CONTACT.MANAGE.CREATE.ADD.TAGS.ALL': 'All tags',
  'CONTACT.MANAGE.CREATE.ADD.TAGS.NEW': 'New tag',
  'CONTACT.MANAGE.CREATE.ADD.TAGS.NAME':
    'Enter a tag name, maximum 100 characters',
  'CONTACT.MANAGE.CREATE.ADD.TAGS.NAME.RPT': 'Tag already exists',
  'CONTACT.MANAGE.CREATE.SUBMIT.DIS':
    'Submit after uploading files and selecting tags',
  'CONTACT.MANAGE.DETAIL.PUTAWAY': 'Collapse',
  'CONTACT.MANAGE.DETAIL.PERSONAL.INFO.TITLE': 'Personal Info',
  'CONTACT.MANAGE.DETAIL.PERSONAL.INFO.CARD.TITLE': 'Email',
  'CONTACT.MANAGE.DETAIL.TAGS.TITLE': 'Tags',
  'CONTACT.MANAGE.DETAIL.TAGS.DEL.TITLE': 'Sure to remove the tag?',
  'CONTACT.MANAGE.DETAIL.TAGS.DEL.DESC':
    'After removing the tag, the contact will no longer be associated with this tag.',
  'CONTACT.MANAGE.DELETE.USER.PERMANENTLY':
    'Delete User Information Permanently',
  'CONTACT.MANAGE.DETAIL.DELETE.MSG': 'Delete contact',
  'CONTACT.MANAGE.DETAIL.DEL.TIPS':
    "This contact's information will be permanently deleted and cannot be restored.",
  'CONTACT.MANAGE.COUNTRY.LANG.STATISTICS.TIPS':
    '<b class="color-primary font-size-20 font-poppins">{total}</b> subscribers in total',
  'CONTACT.MANAGE.COUNTRY.LANG.STATISTICS.INFO':
    'To reduce the bounce rate, please contact SmartLink team<span class="color-primary"> ({customerServiceEmail}) </span>by email one business day in advance to get support if you need to send more than 1 million emails within 24 hours.',

  // 字段设置
  'FIELD.SETTINGS.LIST.TITLE': 'Attributes ',
  'FIELD.SETTINGS.CREATE.FIELD.BTN': 'Create attribute',
  'FIELD.SETTINGS.LIST.TIPS':
    'Select which attributes are shown or rearrange the order. Your changes will be reflected in the contacts list after saving.',
  'FIELD.SETTINGS.PREFERENCE.TIPS1':
    'Select the subscription groups for a contact. After setting up, a link may be included in the email template for the contact to update their preferences.',
  'FIELD.SETTINGS.PREFERENCE.TIPS2': 'More information',
  'FIELD.SETTINGS.LIST.FIELD.SORT': 'Sort',
  'FIELD.SETTINGS.LIST.FIELD.VISIBLE': 'Visible',
  'FIELD.SETTINGS.LIST.FIELD.VISIBLE.TIPS':
    'This attribute in the contact list can be displayed or hidden',
  'FIELD.SETTINGS.LIST.FIELD.NAME': 'Attribute name',
  'FIELD.SETTINGS.LIST.FIELD.TYPE': 'Attribute type',
  'FIELD.SETTINGS.CREATE.FIELD': 'Create attribute',
  'FIELD.SETTINGS.EDIT.FIELD': 'Edit attribute',
  'FIELD.SETTINGS.NAME': 'Name',
  'FIELD.SETTINGS.PLEASE.ENTER.NAME': 'Attribute label must be filled in', // 'Please enter name',
  'FIELD.SETTINGS.NAME.NOT.EMPTY': 'Name cannot be empty',
  'FIELD.SETTINGS.NAME.CHAR.RESTRICTIONS':
    'Attribute names can only be composed of English letters, numbers, and underscores, and must start with a letter.',
  'FIELD.SETTINGS.TYPE': 'Type',
  'FIELD.SETTINGS.PLEASE.SELECT.TYPE': 'Please select type',
  'FIELD.SETTINGS.OPTION.NAME': 'Option name',
  'FIELD.SETTINGS.OPTION.NAME.PLACEHOLDER': 'Enter option name',
  'FIELD.SETTINGS.OPTION.NAME.NOT.EMPTY': 'Option name cannot be empty',
  'FIELD.SETTINGS.OPTION.NAME.REP':
    'The entered option name is duplicate, please check',
  'FIELD.SETTINGS.LIST.DEL.TITLE': 'Delete attribute',
  'FIELD.SETTINGS.LIST.DEL.DESC':
    "<b class='color-333'>'<span>{name}</span>'</b> will be permanently deleted and cannot be restored.",
  'FIELD.SETTINGS.LIST.DEL.TIPS':
    'The attribute is used by the API and cannot be deleted',
  'FIELD.SETTINGS.LIST.SYSTEM.DISABLED.EDIT.TIPS':
    'System fields are not editable',
  'FIELD.SETTINGS.LIST.SYSTEM.DISABLED.DEL.TIPS':
    'System fields are not allowed deleted',
  'FIELD.SETTINGS.LIST.LEAVE.PAGE.TITLE': 'Warm reminder',
  'FIELD.SETTINGS.LIST.LEAVE.PAGE.MESSAGE':
    'The current content has been modified. Determine whether to save it?',
  'FIELD.SETTINGS.BUILT.IN': '(built-in)',
  'FIELD.SETTINGS.SAME.SYSTEM.ATTRIBUTE':
    'Conflict with system field name. Avoid creation',
  'FIELD.SETTINGS.EMAIL.SEND.DETAILS': 'Email-Send details',
  'FIELD.SETTINGS.WHATSAPP.SEND.DETAILS': 'WhatsApp-Send details',
  'FIELD.SETTINGS.SEND.DETAILS': 'Send details',
  'FIELD.SETTINGS.SEND.DETAILS.TIPS':
    'Attributes are inserted as personal information into the email template or subject. Here, you can view the detailed sending information.',
  'FIELD.SETTINGS.SEND.VALUE': 'Sent value',

  // 导入历史
  'IMPORT.HISTORY.LIST.EXPORT.BTN.TIPS':
    'Only accessible to user who imported this file',
  'IMPORT.HISTORY.LIST.IMPORTED.TIME': 'Imported time',
  'IMPORT.HISTORY.LIST.CREATED.BY': 'Created by',
  'IMPORT.HISTORY.LIST.SUCCESS': 'Success',
  'IMPORT.HISTORY.LIST.EXCEPTION': 'Exception',
  'IMPORT.HISTORY.LIST.PROCESS': 'Process',
  'IMPORT.HISTORY.LIST.UPLOAD.CSV.FILE': 'Uploaded CSV file',
  'IMPORT.HISTORY.LIST.SUCCESSFUL.LOGS': 'Successful log',
  'IMPORT.HISTORY.LIST.EXCEPTION.LOGS': 'Exception logs',
  'IMPORT.HISTORY.LIST.UNSUBSCRIBERS': 'Unsubscribers',
  'IMPORT.HISTORY.LIST.NOT.UNSUBSCRIBERS.DOWNLOAD':
    'No unsubscribe users can download',
  'IMPORT.HISTORY.LIST.NOT.FAIL.DOWNLOAD':
    'All contacts successfully imported data without failure',
  'IMPORT.HISTORY.LIST.IN.FORMATION.TIPS':
    'The list is being generated and can be downloaded for viewing once the import is completed',

  // 删除历史
  'DELETE.HISTORY.LIST.DEL.TIME': 'Deletion time',
  'DELETE.HISTORY.LIST.DEL.USER.NUM': 'Number of users deleted',
  'DELETE.HISTORY.LIST.OPERATOR': 'Executed by',
  'DELETE.HISTORY.LIST.ROLE': 'Role',
  'DELETE.HISTORY.LIST.DEL.ACTION': 'Deletion method',
  'DELETE.HISTORY.LIST.BATCH.DEL': 'Batch deleted',
  'DELETE.HISTORY.LIST.SINGLE.DEL': 'Individually deleted',
  
  // 注册表单 - 列表
  'SIGN.UP.FORM.TITLE.DESC':
    "Create a form with custom attributes and share it on your website or on social media. After players fill out the form, their information will be added to 'Contacts'.",
  'SIGN.UP.FORM.TITLE.CREATE': 'Create form',
  'SIGN.UP.FORM.TITLE.ADD': 'New form',
  'SIGN.UP.FORM.CREATE.AND.SHAER': 'Create and share',
  'SIGN.UP.FORM.CREATE.AND.SHAER.DESC':
    'Create a form with custom attributes and share it on your website or on social media',
  'SIGN.UP.FORM.CREATE.GET': 'Get new contacts',
  'SIGN.UP.FORM.CREATE.GET.DESC':
    "After players fill out the form, their information will be added to 'Contacts'.",
  'SIGN.UP.FORM.CREATE': 'Create a form',
  'SIGN.UP.FORM.CREATE.DESC': 'Create a form first',
  'SIGN.UP.FORM.LIST.TITLE': 'Forms list',
  'SIGN.UP.FORM.LIST.SEARCH.PLACEHOLDER': 'Search form',
  'SIGN.UP.FORM.LIST.NAME': 'Form name',
  'SIGN.UP.FORM.LIST.NAME.PLACEHOLDER': 'Enter a name for your form',
  'SIGN.UP.FORM.LIST.NUMBER.OF.CONTACTS': 'New contacts',
  'SIGN.UP.FORM.LIST.TAGS': 'Tags',
  'SIGN.UP.FORM.LIST.STATUS': 'Status',
  'SIGN.UP.FORM.LIST.STATUS.1': 'Active',
  'SIGN.UP.FORM.LIST.STATUS.NEW.1': 'Active',
  'SIGN.UP.FORM.LIST.STATUS.2': 'Inactive',
  'SIGN.UP.FORM.LIST.DELETE.MSG': 'Delete form',
  'SIGN.UP.FORM.LIST.DEL.TIPS':
    "<b class='color-333'>'<span>{name}</span>'</b> will be permanently deleted and cannot be restored. This form will no longer be displayed in filters or statistics.",
  'SIGN.UP.FORM.LIST.VIEW.REPORT': 'View report',
  'SIGN.UP.FORM.LIST.VIEW.REPORT.DIALOG.TITLE': 'Double opt-in report',
  'SIGN.UP.FORM.LIST.VIEW.REPORT.SUB.TITLE1': 'Form statistics',
  'SIGN.UP.FORM.LIST.VIEW.REPORT.SUB.TITLE2': 'Double opt-in statistics',

  // 请输入名称 - 创建、编辑、详情
  'SIGN.UP.FORM.LEAVE.PROMPT.TITLE': 'Leaving form',
  'SIGN.UP.FORM.LEAVE.PROMPT.DESC':
    "Would you like to save the changes you've made?",
  'SIGN.UP.FORM.ACTIVITY.EDIT.TOAST': 'Active sign-up forms cannot be edited',
  'SIGN.UP.FORM.STEP.PLEASE.ENTER.NAME': 'Enter a name for your form',
  'SIGN.UP.FORM.STEP.CREATE': 'Create',
  'SIGN.UP.FORM.STEP.SETTING': 'Settings',
  'SIGN.UP.FORM.STEP.RELEASE': 'Publish',
  'SIGN.UP.FORM.STEP.CONTINUE': 'Continue',
  'SIGN.UP.FORM.STEP.SETTING.SAVE.CONTINUE': 'Save and continue',
  'SIGN.UP.FORM.STEP.ADD.COMPONENT': 'Add component',
  'SIGN.UP.FORM.STEP.ADD.TITLE': 'Title',
  'SIGN.UP.FORM.STEP.ADD.TITLE.TIPS': 'Add a title or subtitle',
  'SIGN.UP.FORM.STEP.ADD.ATTRIBUTE': 'Attribute',
  'SIGN.UP.FORM.STEP.ADD.ATTRIBUTE.TIPS': 'Add an attribute to the form',
  'SIGN.UP.FORM.STEP.ADD.PREFERENCE': 'Subscriber preferences',
  'SIGN.UP.FORM.STEP.ADD.PREFERENCE.TIPS':
    "Add the list of preferences set up under <br/> 'Subscriber preferences'",
  'SIGN.UP.FORM.STEP.ADD.PREFERENCE.DISABLED.TIPS':
    'Create subscriber preferences first',
  'SIGN.UP.FORM.STEP.ADD.AGREEMENT': 'Agreement',
  'SIGN.UP.FORM.STEP.ADD.AGREEMENT.TIPS': 'Add an agreement checkbox',
  'SIGN.UP.FORM.STEP.ADD.CAPTCHA': 'Captcha',
  'SIGN.UP.FORM.STEP.ADD.CAPTCHA.TIPS':
    'Add a captcha to complete registration',
  'SIGN.UP.FORM.STEP.TITLE': 'Title',
  'SIGN.UP.FORM.STEP.MAIN.TITLE': 'Title',
  'SIGN.UP.FORM.STEP.SUB.TITLE': 'Subtitle',
  'SIGN.UP.FORM.STEP.LINK': 'Link',
  'SIGN.UP.FORM.STEP.CANCEL.LINK': 'Cancel link',
  'SIGN.UP.FORM.STEP.LABEL.NAME': 'Attribute title',
  'SIGN.UP.FORM.STEP.HELP.TEXT': 'Attribute description',
  'SIGN.UP.FORM.STEP.EMBEDDED.TEXT': 'Field help text',
  'SIGN.UP.FORM.STEP.CHECKBOX': 'Checkbox',
  'SIGN.UP.FORM.STEP.REQUIRED.FIELD': 'Required',
  'SIGN.UP.FORM.STEP.SELECT.OPTIONS': 'Selection options',
  'SIGN.UP.FORM.STEP.SELECT.OPTIONS.SELECTED.LEN': '{len} selected',
  'SIGN.UP.FORM.STEP.QUESTION.TYPE': 'Question type',
  'SIGN.UP.FORM.STEP.QUESTION.TYPE.SINGLE': 'Single choice',
  'SIGN.UP.FORM.STEP.QUESTION.TYPE.MULTIPLE': 'Multiple choice',
  'SIGN.UP.FORM.STEP.SELECT.FIELD.HEIGHT': 'Select field height',
  'SIGN.UP.FORM.STEP.SINGLE.LINE': 'Single line',
  'SIGN.UP.FORM.STEP.MULTI.LINE': 'Multiple lines',
  'SIGN.UP.FORM.STEP.SELECT.FIELD.WIDTH': 'Select field width',
  'SIGN.UP.FORM.STEP.WIDE': 'Wide',
  'SIGN.UP.FORM.STEP.NARROW': 'Narrow',
  'SIGN.UP.FORM.STEP.COMPONENT.DEL.TITLE': 'Delete component',
  'SIGN.UP.FORM.STEP.COMPONENT.DEL.TIPS':
    'Are you sure you want to delete this component?',
  'SIGN.UP.FORM.STEP.PLEASE.ADD.EMAIL.ATTR': 'Add email field',
  'SIGN.UP.FORM.STEP.PLEASE.ADD.OPTIONS': 'Please add the {name} option',
  'SIGN.UP.FORM.STEP.PLEASE.ADD.CAPTCHA': 'Add captcha component',
  'SIGN.UP.FORM.STEP.NO.ATTR.AVAILABLE.1': 'No attributes selected',
  'SIGN.UP.FORM.STEP.NO.ATTR.AVAILABLE.2': 'No attributes available',
  'SIGN.UP.FORM.STEP.NO.CONFIG': 'No configuration',
  'SIGN.UP.FORM.STEP.CREATE.NO.SELECT': 'Select an attribute and start editing',
  'SIGN.UP.FORM.STEP.CREATE.PREVIEW.NO.SELECT': 'View access only',
  'SIGN.UP.FORM.STEP.SETTING.CONTACT.TITLE': 'Add tag(s)',
  'SIGN.UP.FORM.STEP.SETTING.CONTACT.DESC':
    'When a new contact signs up, the tag(s) below will be added automatically.',
  'SIGN.UP.FORM.STEP.SETTING.TAGS.NONE': 'No tags added',
  'SIGN.UP.FORM.STEP.SETTING.TAGS.DEL.TITLE':
    'Are you sure you want to delete this tag?',
  'SIGN.UP.FORM.STEP.SETTING.TAGS.DEL.DESC':
    'Once the tag is deleted, new contacts added through this form will no longer receive this tag. Please make sure this is intended.',
  'SIGN.UP.FORM.STEP.SETTING.IMPORT.CONTACT.TITLE': 'Opt-in strategy',
  'SIGN.UP.FORM.STEP.SETTING.IMPORT.CONTACT.DESC':
    'If this is not set up, new contacts will be added to the contacts list directly after submitting a form.<br/>You can set up player journey for this form. ',
  'SIGN.UP.FORM.STEP.SETTING.IMPORT.CONTACT.SETTING': 'Edit settings',
  'SIGN.UP.FORM.STEP.SETTING.IMPORT.CONTACT.NOTE': 'Note:',
  'SIGN.UP.FORM.STEP.SETTING.IMPORT.CONTACT.AUTOMATE.1':
    'Player journey can send a confirmation email to contacts who are added through a form. After the contact confirms their email, they will be added to the contacts list.',
  'SIGN.UP.FORM.STEP.SETTING.IMPORT.CONTACT.AUTOMATE.2':
    'Player journey can send welcome emails to newly added contacts.',
  'SIGN.UP.FORM.STEP.SETTING.IMPORT.CONTACT.DOUBLE': 'Double opt-in settings',
  'SIGN.UP.FORM.STEP.SETTING.STATUS': 'Status: ',
  'SIGN.UP.FORM.STEP.SETTING.GO.TITLE': 'Unsaved changes',
  'SIGN.UP.FORM.STEP.SETTING.GO.DESC':
    'Changes will be lost if you leave without saving.',
  'SIGN.UP.FORM.STEP.RELEASE.TITLE': 'Publication',
  'SIGN.UP.FORM.STEP.RELEASE.STATUS.1': 'Active',
  'SIGN.UP.FORM.STEP.RELEASE.STATUS.2': 'Inactive',
  'SIGN.UP.FORM.STEP.RELEASE.STATUS.DESC.1':
    "Active forms can collect information from players, the information filled in will be added to 'Contacts'.",
  'SIGN.UP.FORM.STEP.RELEASE.STATUS.DESC.2':
    "This form is 'Inactive'. When a user fills in this form, their information will not be synchronized to the Contacts list.",
  'SIGN.UP.FORM.STEP.RELEASE.STATUS.CHANGE.TITLE.2': 'Activate form',
  'SIGN.UP.FORM.STEP.RELEASE.STATUS.CHANGE.DESC.2':
    'Users can fill in and update their information through this form.',
  'SIGN.UP.FORM.STEP.RELEASE.STATUS.CHANGE.TITLE.1': 'Deactivate form',
  'SIGN.UP.FORM.STEP.RELEASE.STATUS.CHANGE.DESC.1':
    'Deactivated forms can still be filled in, but any information submitted through these forms will not be updated in SmartLink.',
  'SIGN.UP.FORM.STEP.RELEASE.STATUS.CHANGE.CONFIRM':
    'Type <b>DEACTIVATE</b> to confirm',
  'SIGN.UP.FORM.STEP.RELEASE.STATUS.CHANGE.TO.CLOSE': 'DEACTIVATE',
  'SIGN.UP.FORM.STEP.RELEASE.STATUS.CHANGE.TO.1':
    "This form has been set to 'Active'",
  'SIGN.UP.FORM.STEP.RELEASE.STATUS.CHANGE.TO.2':
    "This form has been set to 'Inactive'",
  'SIGN.UP.FORM.STEP.RELEASE.SHARE.LINK.TITLE': 'Form link',
  'SIGN.UP.FORM.STEP.RELEASE.SHARE.LINK.COPY': 'Copy the form link',
  'SIGN.UP.FORM.STEP.RELEASE.SHARE.LINK.COPY.SUCCESS': 'Copy successfully',
  'SIGN.UP.FORM.STEP.RELEASE.SHARE.FACEBOOK': 'Facebook',
  'SIGN.UP.FORM.STEP.RELEASE.SHARE.TWWTTER': 'X',
  'SIGN.UP.FORM.STEP.RELEASE.SHARE.QRCODE': 'Show QR code',
  'SIGN.UP.FORM.STEP.RELEASE.QRCODE.TITLE': 'QR code',
  'SIGN.UP.FORM.STEP.RELEASE.QRCODE.DESC': 'Scan the QR code to open the form',
  'SIGN.UP.FORM.STEP.SAVE.SENDER.ADDRESS.WARN':
    'Please verify the sender address configurations for the double opt-in emails.',
  'SIGN.UP.FORM.STEP.SAVE.SENDER.NAME.WARN':
    'Please verify the sender name configurations for the double opt-in emails.',
  'SIGN.UP.FORM.STEP.SAVE.SENDER.DOAMIN.NAME.WARN':
    'Please verify the sender name and email address configurations for the double opt-in emails.',
};
